<form #formEndereco="ngForm">
    <div class="row">
        <h2>Endereço Residencial - Cliente</h2>
        <app-endereco [isEnderecoPesadoBrasil]="true" icon="residencial" label="CEP" name="enderecoResidencial" [(ngModel)]="fichaCadastro._client.enderecos"
            ngDefaultControl [fichaCadastroPasso]="fichaCadastro.passo" [fichaCadastro]="fichaCadastro">
        </app-endereco>

        <app-residencia
            *ngIf="fichaCadastro.isPesados"
            [fichaCadastro]="fichaCadastro"
            (residenciaFormEmit)="onChangeInfoResidencia($event)"
            (residenciaFormValidEmit)="residenciaFormValido = $event">
        </app-residencia>
    </div>
    <!-- COMERCIAL -->
    <div *ngIf="isInformarEnderecoComercial()" class="row">
        <h2>Endereço Comercial - Cliente</h2>
        <app-endereco icon="icon zip-code" label="CEP" name="enderecoComercial" [(ngModel)]="enderecoEmpresa"
            ngDefaultControl>
        </app-endereco>
    </div>
    <!-- SELECIONAR ENDEREÇO PARA CORRESPONDÊNCIA -->
    <div class="row">
        <div class="form-group">
            <span class="icon email"></span>
            <div class="inputs">
                <label for="user-mail-address">Endereço para correspondência</label>
                <select name="user-mail-address" id="user-mail-address" class="form-control" required [(ngModel)]="fichaCadastro._client.tipoEnderecoCorrespondencia">
                    <option value="undefined" hidden selected>Selecione</option>
                    <option value="1">Residencial</option>
                    <option *ngIf="isInformarEnderecoComercial()" value="2">Comercial</option>
                    <option value="7">Outro</option>
                </select>
            </div>
        </div>
    </div>
</form>
<form #formEnderecoOutro="ngForm">
    <!-- OUTRO -->
    <div class="row mail-address" [ngClass]="{'dn': fichaCadastro._client.tipoEnderecoCorrespondencia !== '7'}">
        <h2>Endereço Correspondência - Cliente</h2>
        <app-endereco icon="icon zip-code" label="CEP" name="enderecoComercial" [(ngModel)]="fichaCadastro._client.enderecoCorrespondencia"
            ngDefaultControl>
        </app-endereco>
    </div>
</form>
<!-- BOTÕES -->
<div class="row">
    <div class="marginT30 form-group tab-buttons">
        <a (click)="onClickPrevious()" class="bt-back btn btn-border-orange pull-left"><em class="fa fa-arrow-left mrBt"></em>
            Voltar</a>
        <a class="bt-go btn btn-full-orange pull-right" [ngClass]="{'disabled': bloquearProximo()}"
            (click)="onClickNext()">Continuar <em class="fa fa-arrow-right mlBt"></em></a>
    </div>
</div>
